import {Stepper} from '@cvent/carina/components/Stepper';

type StepperDisplayStep = {
  id: string;
  name: string;
  showTooltip?: boolean;
};

type StepperComponentProps = {
  currentStepId: string;
  steps: StepperDisplayStep[];
};

export const StepperComponent = ({
  currentStepId,
  steps,
}: StepperComponentProps) => {
  if (!steps.length) {
    return null;
  }

  const hasCurrentStep = steps.some((step) => step.id === currentStepId);
  const activeStepId = hasCurrentStep ? currentStepId : steps[0].id;

  return (
    <Stepper
      currentStep={{step: activeStepId}}
      steps={steps}
      presentation="horizontal"
      csx={{
        stepper: {
          slots: {
            base: '!flex !flex-row !flex-nowrap !justify-center -ml-6',
          },
        },
        mobileStepper: {
          slots: {
            base: 'hidden',
          },
        },
        horizontalStep: {
          slots: {
            container: 'p-0 w-[126px] sm:w-[174px]',
          },
        },
      }}
    />
  );
};
